import { Button, Divider, Modal } from '@mairistem/composants';
import React from 'react';
import PolitiqueConfidentialiteEnum from '../../enums/PolitiqueConfidentialiteEnum';

interface ConfidentialiteModalProps {
	onCheck: (state: PolitiqueConfidentialiteEnum) => void;
}

const ConfidentialiteModal = ({ onCheck }: ConfidentialiteModalProps) => {
	const handleRefuse = () => {
		onCheck(PolitiqueConfidentialiteEnum.REFUSED);
	};

	const handleAccept = () => {
		onCheck(PolitiqueConfidentialiteEnum.ACCEPTED);
	};

	return (
		<Modal open data-testid="politique-confidentialite-modal" size="small">
			<Modal.Header>Politique de confidentialité</Modal.Header>
			<Modal.Content className="politique-confidentialite-modal-content">
				<p>
					En utilisant ce site, vous autorisez le Groupe JVS et ses filiales à
					utiliser les données à caractère personnel collectées à travers ce
					site dans le but d’assurer l’exécution du traitement de création de
					comptes ixChange2 pour vos nouveaux bénéficiaires.
				</p>
				<Divider hidden />
				<p>
					Les données collectées via ce site seront supprimées à l’issue de leur
					traitement. JVS s’engage à gérer les données conformément aux bonnes
					pratiques et recommandations liées au RGPD, comme indiqué dans notre
					politique de confidentialité consultable à l’adresse ci-dessous.
				</p>
				<Divider hidden />
				<p>
					<a
						className="politique-confidentialite-link"
						href="https://www.calameo.com/read/00027442620a607eafa8c?authid=IDXXYkJ5jD4c"
						target="_blank"
						rel="noreferrer"
					>
						Politique de confidentialité
					</a>
				</p>
				<Divider hidden />
				<p>
					Vous devez accepter cette politique pour pouvoir accéder au site web.
				</p>
			</Modal.Content>
			<Modal.Actions>
				<Button
					onClick={handleRefuse}
					data-testid="refuse-confidentialite-modal-btn"
				>
					Refuser
				</Button>
				<Button
					primary
					onClick={handleAccept}
					data-testid="accept-confidentialite-modal-btn"
					className="confidentialite-accept-button"
				>
					Accepter
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ConfidentialiteModal;
